import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { SupplierStats } from './SupplierStats';
import { SupplierList } from './SupplierList';
export function SupplierOverview() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-53">
      <main className="max-w-[1440px] mx-auto px-6 py-8" data-id="element-54">
        <div className="mb-6" data-id="element-55">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-56">
            Supplier Management
          </h1>
          <p className="text-gray-600" data-id="element-57">
            Monitor and manage supplier compliance across your portfolio
          </p>
        </div>
        {/* Stats Overview */}
        <SupplierStats data-id="element-58" />
        <div className="space-y-6 mt-8" data-id="element-59">
          {/* Search and Filters */}
          <div className="bg-white rounded-lg border p-4" data-id="element-60">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-61">
              <div className="flex-1 relative" data-id="element-62">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-63" />
                <input type="text" placeholder="Search suppliers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-64" />
              </div>
              <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="w-full sm:w-auto px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-65">
                <option value="all" data-id="element-66">All Suppliers</option>
                <option value="compliant" data-id="element-67">🟢 Compliant</option>
                <option value="at-risk" data-id="element-68">🟡 At Risk</option>
                <option value="partial" data-id="element-69">🟠 Partially Compliant</option>
                <option value="non-compliant" data-id="element-70">🔴 Non-Compliant</option>
              </select>
            </div>
          </div>
          {/* Supplier List */}
          <SupplierList searchQuery={searchQuery} filterStatus={filterStatus} data-id="element-71" />
        </div>
      </main>
    </div>;
}